import {h} from 'ui/Framework';

export default h('svg', {
  width: '35',
  height: '44',
  viewBox: '-1 -1 37 46',
  xmlns: 'http://www.w3.org/2000/svg'
}, [
  h('g', {
    fill: 'none',
    fillRule: 'evenodd'
  }, [
    h('g', [
      h('g', [
        h('path', {
          fill: '#E7EBF0',
          d: 'M7 36.56h20v-16H7z'
        }),
        h('path', {
          stroke: '#9FAAC0',
          d: 'M.5 0h33.845v43.08H.5z'
        }),
        h('path', {
          d: 'M11.118 14.56h-.648V8.764H8.337v-.576h4.915v.576h-2.134v5.796zm3.564 0h-.612v-4.212h.612v4.212zm.127-5.832a.4.4 0 0 1-.135.31.435.435 0 0 1-.297.122.435.435 0 0 1-.298-.122.4.4 0 0 1-.135-.31.4.4 0 0 1 .135-.31.435.435 0 0 1 .297-.122c.109 0 .207.04.298.121a.4.4 0 0 1 .135.31zm3.402 2.133h-1.188v2.457c0 .156.014.285.044.387a.55.55 0 0 0 .131.238.445.445 0 0 0 .203.117.966.966 0 0 0 .252.032c.084 0 .172-.012.265-.036.093-.024.181-.057.265-.1l.027.532c-.108.042-.22.073-.337.094a2.169 2.169 0 0 1-.383.032c-.114 0-.233-.015-.36-.045a.91.91 0 0 1-.616-.513 1.32 1.32 0 0 1-.104-.567V10.86h-.873v-.513h.873V9.16h.613v1.188h1.188v.513zm1.584 3.699h-.613V7.756h.613v6.804zm4.85-2.43c-.018-.396-.145-.725-.382-.986-.237-.26-.574-.391-1.013-.391-.204 0-.392.037-.567.112a1.5 1.5 0 0 0-.773.747 1.422 1.422 0 0 0-.136.518h2.871zm.622.198v.135c0 .048-.003.099-.01.153h-3.492c.006.21.048.408.127.594a1.5 1.5 0 0 0 .323.486c.139.138.3.247.486.328.187.081.387.122.604.122.318 0 .592-.074.823-.22.231-.148.406-.317.526-.51l.46.36c-.253.319-.53.547-.833.685a2.328 2.328 0 0 1-.976.207 2.24 2.24 0 0 1-.869-.167 2.034 2.034 0 0 1-.689-.463 2.196 2.196 0 0 1-.454-.702 2.297 2.297 0 0 1-.166-.882c0-.318.053-.612.162-.882a2.07 2.07 0 0 1 1.962-1.332c.33 0 .62.055.872.166a1.8 1.8 0 0 1 .63.45c.169.19.296.41.383.662.087.252.13.522.13.81z',
          fill: '#A3A9B2'
        })
      ])
    ])
  ])
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/reference-card-widget.es6.js